import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";
import { DamImage } from "@/utils/dam.utils";
import { ConditionalWrapper } from "@/utils/helpers";

const FAVVCODE_DOCUMENT_PREFIX = "PES";

type FavvCodeProps = {
    code?: string | null;
};

const FavvCode = ({ code }: FavvCodeProps) => {
    const { t } = useGranite();

    const displayFavvDocument =
        !!code && code.startsWith(FAVVCODE_DOCUMENT_PREFIX);

    return (
        <section className={cn("tw:mb-4")}>
            <Col className={cn("tw:border-b tw:border-primary")}>
                <div className={cn("tw:py-2 tw:font-bold")}>
                    {t("productDetail.featureList.favvCode.title")}
                </div>
            </Col>
            <div>
                <Col>
                    <Row className={cn("tw:border-b tw:border-border")}>
                        <Col
                            sm={6}
                            className={cn("tw:bg-grey")}
                        >
                            <div className={cn("tw:py-2")}>
                                {t(
                                    "productDetail.featureList.favvCode.number.label"
                                )}
                            </div>
                        </Col>
                        <Col
                            sm={6}
                            className={cn("tw:bg-background")}
                        >
                            <div className={cn("tw:py-2")}>{code}</div>
                        </Col>
                    </Row>
                </Col>
                {displayFavvDocument && (
                    <Col>
                        <Row className={cn("tw:border-b tw:border-border")}>
                            <Col
                                sm={6}
                                className={cn("tw:bg-grey")}
                            >
                                <div className={cn("tw:py-2")}>
                                    {t(
                                        "productDetail.featureList.favvCode.image.label"
                                    )}
                                </div>
                            </Col>
                            <Col
                                sm={6}
                                className={cn("tw:bg-background")}
                            >
                                <div className={cn("tw:py-2")}>
                                    <ConditionalWrapper
                                        wrapper={(children) => (
                                            <a
                                                href={
                                                    Config["external-links"][
                                                        "plant-protection-products"
                                                    ]
                                                }
                                                target={"_blank"}
                                                rel={"noopener"}
                                            >
                                                {children}
                                            </a>
                                        )}
                                        condition={
                                            !!Config["external-links"][
                                                "plant-protection-products"
                                            ]
                                        }
                                    >
                                        <img
                                            src={DamImage.icon.label.gewasbescherming()}
                                            alt={t(
                                                "productDetail.featureList.favvCode.image.alt"
                                            )}
                                        />
                                    </ConditionalWrapper>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                )}
            </div>
        </section>
    );
};

export { FavvCode };
